import { useId } from "react"
import { starColorFor } from "../lib/starPalette"

// The mark uses the atlas's own astrophysical palette and 0.42 resting edge
// opacity; only the camera changes—from Three.js space to a tiny SVG viewport.
const MARK_STARS = [
  { x: 52, y: 12, r: 2.6 },
  { x: 38, y: 8, r: 2.1 },
  { x: 23, y: 13, r: 2.8 },
  { x: 13, y: 25, r: 2.2 },
  { x: 10, y: 39, r: 3.1 },
  { x: 15, y: 53, r: 2.1 },
  { x: 27, y: 62, r: 2.7 },
  { x: 42, y: 64, r: 2 },
  { x: 54, y: 57, r: 2.8 }
].map((star, index) => ({ ...star, color: starColorFor("concept", `conceptive-mark-${index}`) }))

export function ConceptiveConstellationMark({ className = "", title = null }) {
  const reactId = useId().replace(/:/g, "")
  const glowId = `conceptive-mark-glow-${reactId}`
  const edgeId = `conceptive-mark-edge-${reactId}`

  return (
    <svg
      className={`conceptive-constellation-mark ${className}`.trim()}
      viewBox="0 0 64 72"
      role={title ? "img" : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <filter id={glowId} x="-100%" y="-100%" width="300%" height="300%">
          <feGaussianBlur stdDeviation="2.8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id={edgeId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#9eb8ff" stopOpacity="0.18" />
          <stop offset="0.52" stopColor="#e6edff" stopOpacity="0.42" />
          <stop offset="1" stopColor="#bd9cff" stopOpacity="0.24" />
        </linearGradient>
      </defs>

      <g fill="none" stroke={`url(#${edgeId})`} strokeWidth="0.9" strokeLinecap="round">
        {MARK_STARS.slice(0, -1).map((star, index) => {
          const next = MARK_STARS[index + 1]
          return <line key={`${star.x}-${star.y}`} data-constellation-edge="true" x1={star.x} y1={star.y} x2={next.x} y2={next.y} />
        })}
      </g>

      <g filter={`url(#${glowId})`}>
        {MARK_STARS.map((star, index) => (
          <g key={`${star.x}-${star.y}`} data-constellation-star="true">
            <circle cx={star.x} cy={star.y} r={star.r * 2.5} fill={star.color} opacity={index === 4 ? 0.15 : 0.08} />
            <circle cx={star.x} cy={star.y} r={star.r} fill={star.color} />
            <circle cx={star.x - star.r * 0.22} cy={star.y - star.r * 0.22} r={Math.max(0.55, star.r * 0.34)} fill="#ffffff" opacity="0.96" />
          </g>
        ))}
      </g>
    </svg>
  )
}
